import PropTypes from 'prop-types';
import axios from 'axios';
import getSubmitData from './getSubmitData';
import submitFormHubSpot from './submitFormHubSpot';
import getHSCookie from './getHSCookie';

const defaultProps = {
  data: {
    setSubmitting: () => null,
    onSuccess: () => null,
    onError: () => null,
    cookie: null,
  },
};

const propTypes = {
  form: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  data: PropTypes.shape({
    setSubmitting: PropTypes.func,
    onSuccess: PropTypes.func,
    onError: PropTypes.func,
    cookie: PropTypes.string,
  }),
};

export default function submitForm(form, values, {
  setSubmitting,
  onSuccess,
  onError,
  cookie,
}) {
  setSubmitting(true);

  const submitData = getSubmitData(values, getHSCookie(cookie));

  // First, get the client IP address
  axios.get('https://api.ipify.org/')
    .then(({ data: ip }) => {
      submitFormHubSpot(form, {
        ...submitData,
        ipAddress: ip,
      }, {
        setSubmitting,
        onSuccess,
        onError,
      });
    })
    .catch(() => {
      submitFormHubSpot(form, submitData, {
        setSubmitting,
        onSuccess,
        onError,
      });
    });
}

submitForm.defaultProps = defaultProps;
submitForm.propTypes = propTypes;
